import React from 'react';
import { MdConfirmationNumber, MdIosShare, MdMail } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Divider from 'legacy/common/components/wysiwyg-form/Divider';
import { useEventPageContext } from './context/EventPageContext';

const GuestEventOptions: React.FC = () => {
  const { t } = useTranslation(['events']);
  const {
    event,
    toggleViewContactsModal,
    toggleCheckout,
    toggleShareModal,
    toggleManageEvent,
    isManageEventModalOpen,
    isLoggedIn,
    canShare
  } = useEventPageContext();
  const onOptionClick = (action) => () => {
    toggleManageEvent();
    action();
  };

  return (
    <Modal
      type={ModalType.SMALL}
      onClose={toggleManageEvent}
      autoHeight
      hideCloseButton
      visible={isManageEventModalOpen}
    >
      <div className="p-4 flex flex-col gap-3">
        <Button
          type={ButtonType.Inverted}
          icon={<MdConfirmationNumber size={20} />}
          onClick={onOptionClick(toggleCheckout)}
          disabled={event.activeStatus === 'past'}
        >
          {t('events:actions.getTickets')}
        </Button>
        {isLoggedIn && (
          <Button
            type={ButtonType.Inverted}
            icon={<MdMail size={20} />}
            onClick={onOptionClick(toggleViewContactsModal)}
            testId="button-contact-host"
          >
            {t('events:actions.contactHost')}
          </Button>
        )}
        {canShare && (
          <>
            <Divider size={4} />
            <div className="flex flex-col mt-4">
              <Button
                type={ButtonType.Inverted}
                onClick={onOptionClick(toggleShareModal)}
                icon={<MdIosShare size={20} />}
              >
                {t('events:actions.shareEvent')}
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default GuestEventOptions;
